import {ActionProgressState} from "../../../action-manager/action/action-progress-state";

export class JobRunProgress extends ActionProgressState {

  public id: number;
  public websiteId: number;
  public jobId: string;
  public status: string;
  public active: boolean;
  public creationDate: Date;
  public updatedDate: Date;

}
